var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import get from "lodash/get";
export var DYNAMIC_WIZARD_TYPES = ['function', 'object'];
var createSchema = function (_a) {
    var _b, _c;
    var formOptions = _a.formOptions, fields = _a.fields;
    var values = formOptions.getState().values;
    var schema = [];
    var field = fields[0]; // find first wizard step
    var index = -1;
    var _loop_1 = function () {
        index += 1;
        schema = __spreadArray(__spreadArray([], schema), [
            {
                name: field.name,
                title: field.title,
                substepOf: ((_b = field.substepOf) === null || _b === void 0 ? void 0 : _b.name) || field.substepOf,
                substepOfTitle: ((_c = field.substepOf) === null || _c === void 0 ? void 0 : _c.title) || field.substepOf,
                index: index,
                groupName: field.groupName,
                primary: !schema[schema.length - 1] || !field.substepOf || field.substepOf !== schema[schema.length - 1].substepOf
            }
        ]);
        var nextStep = field.nextStep;
        if (typeof field.nextStep === 'object') {
            nextStep = nextStep.stepMapper[get(values, nextStep.when)];
        }
        if (typeof field.nextStep === 'function') {
            nextStep = field.nextStep({ values: values });
        }
        if (nextStep) {
            field = fields.find(function (_a) {
                var name = _a.name;
                return name === nextStep;
            });
        }
        else {
            field = undefined;
        }
    };
    while (field) {
        _loop_1();
    }
    return schema;
};
var handleNext = function (state, nextStep, formOptions, fields) {
    var _a;
    if (!nextStep) {
        return state;
    }
    var newActiveIndex = state.activeStepIndex + 1;
    var shouldInsertStepIntoHistory = state.prevSteps.includes(state.activeStep);
    return __assign(__assign({}, state), { registeredFieldsHistory: __assign(__assign({}, state.registeredFieldsHistory), (_a = {}, _a[state.activeStep] = formOptions.getRegisteredFields(), _a)), activeStep: nextStep, prevSteps: shouldInsertStepIntoHistory ? state.prevSteps : __spreadArray(__spreadArray([], state.prevSteps), [state.activeStep]), activeStepIndex: newActiveIndex, maxStepIndex: newActiveIndex > state.maxStepIndex ? newActiveIndex : state.maxStepIndex, navSchema: state.isDynamic
            ? createSchema({
                fields: fields,
                formOptions: formOptions
            })
            : state.navSchema });
};
export var findCurrentStep = function (activeStep, fields) { return fields.find(function (_a) {
    var name = _a.name;
    return name === activeStep;
}); };
var derivePreviousSteps = function (fields, index) {
    return fields.slice(0, index).map(function (_a) {
        var name = _a.name;
        return name;
    });
};
var jumpToStep = function (state, index, valid, fields, crossroads, formOptions) {
    if (index === state.activeStepIndex) {
        return state;
    }
    var clickOnPreviousStep = state.prevSteps[index];
    if (clickOnPreviousStep) {
        var originalActiveStep = void 0;
        var includeActiveStep = state.prevSteps.includes(state.activeStep, fields);
        originalActiveStep = state.activeStep;
        var newState = __assign(__assign({}, state), { activeStep: state.prevSteps[index], prevSteps: includeActiveStep ? state.prevSteps : __spreadArray(__spreadArray([], state.prevSteps), [state.activeStep]), activeStepIndex: index });
        var INDEXING_BY_ZERO = 1;
        var currentStep = findCurrentStep(newState.prevSteps[index], fields);
        var currentStepHasStepMapper = DYNAMIC_WIZARD_TYPES.includes(typeof currentStep.nextStep);
        var hardcodedCrossroads = crossroads;
        var dynamicStepShouldDisableNav = newState.isDynamic && currentStepHasStepMapper;
        var invalidStepShouldDisableNav = valid === false;
        var updatedState = __assign({}, newState);
        if (dynamicStepShouldDisableNav && !hardcodedCrossroads) {
            updatedState = __assign(__assign({}, updatedState), { navSchema: createSchema({
                    formOptions: formOptions,
                    fields: fields
                }), prevSteps: derivePreviousSteps(fields, index), maxStepIndex: index });
        }
        else if (currentStep.disableForwardJumping) {
            updatedState = __assign(__assign({}, updatedState), { prevSteps: derivePreviousSteps(fields, index), maxStepIndex: index });
        }
        else if (invalidStepShouldDisableNav) {
            var indexOfCurrentStep = newState.prevSteps.indexOf(originalActiveStep);
            updatedState = __assign(__assign({}, updatedState), { prevSteps: derivePreviousSteps(fields, indexOfCurrentStep + INDEXING_BY_ZERO), maxStepIndex: newState.prevSteps.slice(0, indexOfCurrentStep + INDEXING_BY_ZERO).length - INDEXING_BY_ZERO });
        }
        return updatedState;
    }
    return state;
};
var reducer = function (state, _a) {
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case 'finishLoading':
            return __assign(__assign({}, state), { loading: false, prevSteps: derivePreviousSteps(payload.fields, state.prevSteps.length), navSchema: createSchema({
                    fields: payload.fields,
                    formOptions: payload.formOptions
                }) });
        case 'handleNext':
            return handleNext(state, payload.nextStep, payload.formOptions, payload.fields);
        case 'setPrevSteps':
            return __assign(__assign({}, state), { prevSteps: derivePreviousSteps(payload.fields, state.activeStepIndex), maxStepIndex: state.activeStepIndex, navSchema: createSchema({
                    fields: payload.fields,
                    formOptions: payload.formOptions
                }) });
        case 'jumpToStep':
            return jumpToStep(state, payload.index, payload.valid, payload.fields, payload.crossroads, payload.formOptions);
        default:
            return state;
    }
};
export default reducer;
